var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7815 2.26387C5.92659 2.24538 6.07341 2.24538 6.2185 2.26387C6.44958 2.29332 6.7076 2.404 7.10929 2.72659C7.52282 3.05869 8.01086 3.5495 8.72 4.26499L10.4673 6.02796C10.7589 6.32216 11.2338 6.32427 11.528 6.03269C11.8222 5.74111 11.8243 5.26624 11.5327 4.97204L9.7539 3.1773C9.08396 2.50133 8.53641 1.94886 8.04854 1.55706C7.54122 1.14963 7.02628 0.854695 6.40816 0.775909C6.13714 0.741364 5.86286 0.741364 5.59184 0.775909C4.97372 0.854695 4.45878 1.14963 3.95146 1.55706C3.46358 1.94886 2.91604 2.50134 2.24609 3.17732L0.467309 4.97204C0.175726 5.26624 0.177844 5.74111 0.472041 6.03269C0.766238 6.32427 1.24111 6.32216 1.53269 6.02796L3.28 4.26499C3.98914 3.5495 4.47718 3.05869 4.89071 2.72659C5.2924 2.404 5.55042 2.29332 5.7815 2.26387Z",
    fill: "#1592D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenArrow);
export default __webpack_public_path__ + "static/media/openArrow.2e9acce0cd422ccb15ca00f1db9c16d7.svg";
export { ForwardRef as ReactComponent };